<template>
  <div class="columns">
    <div class="column is-one-fifth container">
      <div class="search-links">
        <hr />
        <ul>
          <li><router-link :to="{ name: 'gci' }">Search GCI</router-link></li>
          <li>
            <router-link :to="{ name: 'gcibrowse' }" class="active"
              >Browse GCI</router-link
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="column is-four-fifth container">
      <div v-show="searchedFilter">
        <span v-if="filterDescription" class="page_header"
          ><h5>{{ this.filterDescription }}</h5></span
        ><br />
      </div>
      <div
        v-show="searchedFilter"
        class="search-results-info"
        @change="submit()"
      >
        Results {{ this.startResults }} - {{ this.endResults }} of about
        {{ this.searchTotals }}. Page {{ this.currentPage }} of
        {{ this.totalPages }}. Results per page:
        <select v-model="sizeValue">
          <option
            v-for="option in selectOptions"
            v-bind:value="option.value"
            :key="option.value"
          >
            {{ option.text }}
          </option>
        </select>
      </div>

      <hr v-show="searchedFilter" />

      <b-field class="pagination" v-show="searched && searchedFilter">
        <button
          class="button is-small"
          v-on:click="prevButton"
          v-if="this.fromValue !== 0"
        >
          <b-icon icon="chevron-left" size="is-small"></b-icon>
          <span class="prev">Previous</span>
        </button>
        <button
          class="button is-small"
          v-on:click="nextButton"
          v-if="this.currentPage !== this.totalPages"
        >
          <span class="next">Next</span>
          <b-icon icon="chevron-right" size="is-small"></b-icon>
        </button>
      </b-field>

      <div v-show="!searched && searchedFilter">
        <LoadingBar />
      </div>

      <table cellpadding="0" cellspacing="0" border="0" v-show="searched">
        <tr
          class="results"
          v-show="searchedFilter"
          v-for="results in searchResults"
          :key="results._id"
        >
          <td v-if="results._source.image" class="results-image">
            <img
              v-bind:src="
                'http://www.getty.edu/conservation/publications_resources/images/icons/' +
                  results._source.image
              "
            />
          </td>
          <td v-else-if="results._source.page" class="results-image">
            <img
              src="http://www.getty.edu/conservation/publications_resources/images/icons/icon_ethers.jpg"
            />
          </td>
          <td
            v-else-if="results._source.TYPE === undefined"
            class="results-image"
          >
            <img
              src="http://www.getty.edu/conservation/publications_resources/images/icons/gci_generic_icon.jpg"
            />
          </td>
          <td
            v-else-if="results._source.TYPE.indexOf('ccc') > -1"
            class="results-image"
          >
            <img
              src="http://www.getty.edu/conservation/publications_resources/images/icons/current_project_icon.jpg"
            />
          </td>
          <td
            v-else-if="results._source.TYPE.indexOf('cnf') > -1"
            class="results-image"
          >
            <img
              src="http://www.getty.edu/conservation/publications_resources/images/icons/conference_icon.jpg"
            />
          </td>
          <td
            v-else-if="results._source.TYPE.indexOf('ppp') > -1"
            class="results-image"
          >
            <img
              src="http://www.getty.edu/conservation/publications_resources/images/icons/past_project_icon.jpg"
            />
          </td>
          <td
            v-else-if="results._source.TYPE.indexOf('tch') > -1"
            class="results-image"
          >
            <img
              src="http://www.getty.edu/conservation/publications_resources/images/icons/teaching_icon.jpg"
            />
          </td>
          <td v-else class="results-image">
            <img
              src="http://www.getty.edu/conservation/publications_resources/images/icons/gci_generic_icon.jpg"
            />
          </td>
          <td>
            <span v-if="results._source.title" class="results-title"
              ><a :href="results._source.url">{{
                results._source.title
              }}</a></span
            >
            <span v-else
              ><a :href="results._source.url">{{
                results._source.url
              }}</a></span
            >
            <span v-if="results._source.DESCRIPTION">{{
              results._source.DESCRIPTION
            }}</span>
            <span v-else-if="results._source.description">{{
              results._source.description
            }}</span>
            <table class="sublinks">
              <tr v-if="results._source.subtitle1" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl1">{{
                  results._source.subtitle1
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle2" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl2">{{
                  results._source.subtitle2
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle3" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl3">{{
                  results._source.subtitle3
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle4" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl4">{{
                  results._source.subtitle4
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle5" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl5">{{
                  results._source.subtitle5
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle6" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl6">{{
                  results._source.subtitle6
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle7" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl7">{{
                  results._source.subtitle7
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle8" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl8">{{
                  results._source.subtitle8
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle9" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl9">{{
                  results._source.subtitle9
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle10" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl10">{{
                  results._source.subtitle10
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle11" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl11">{{
                  results._source.subtitle11
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle12" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl12">{{
                  results._source.subtitle12
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle13" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl13">{{
                  results._source.subtitle13
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle14" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl14">{{
                  results._source.subtitle14
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle15" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl15">{{
                  results._source.subtitle15
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle16" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl16">{{
                  results._source.subtitle16
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle17" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl17">{{
                  results._source.subtitle17
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle18" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl18">{{
                  results._source.subtitle18
                }}</a>
              </tr>
              <tr v-if="results._source.subtitle19" class="results-title">
                <img src="http://www.getty.edu/global/images/line.gif" />
                <a :href="'http://www.getty.edu' + results._source.suburl19">{{
                  results._source.subtitle19
                }}</a>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <hr v-show="searchedFilter" />

      <b-field class="pagination" v-show="searched && searchedFilter">
        <button
          class="button is-small"
          v-on:click="prevButton"
          v-if="this.fromValue !== 0"
        >
          <b-icon icon="chevron-left" size="is-small"></b-icon>
          <span class="prev">Previous</span>
        </button>
        <button
          class="button is-small"
          v-on:click="nextButton"
          v-if="this.currentPage !== this.totalPages"
        >
          <span class="next">Next</span>
          <b-icon icon="chevron-right" size="is-small"></b-icon>
        </button>
      </b-field>
    </div>
  </div>
</template>

<script>
import { getClient } from "@/services/elasticsearch";
import LoadingBar from "@/components/LoadingBar";

export default {
  name: "BrowseGCIResults",
  inject: ["runtimeConfig"],
  data() {
    return {
      index: {},
      hits: {},
      type: "",
      area: "",
      region: "",
      searchedFilter: false,
      searchFilter: false,
      archShow: false,
      buildShow: false,
      consShow: false,
      decSurfShow: false,
      histShow: false,
      modShow: false,
      recShow: false,
      artShow: false,
      devShow: false,
      modContShow: false,
      photoShow: false,
      prevenShow: false,
      consEdShow: false,
      subSaharanShow: false,
      midEastShow: false,
      euroShow: false,
      asiaShow: false,
      naShow: false,
      saShow: false,
      oceaShow: false,
      clickedLink: false,
      query: "",
      filterBy: "",
      filter: "",
      filterDescription: "",
      searchText: "",
      inputUrl: "",
      searchTotals: "",
      searchResults: [],
      fromValue: 0,
      sizeValue: 50,
      startResults: 1,
      endResults: 50,
      currentPage: 1,
      endPage: 1,
      totalPages: 1,
      imageSearch: "",
      selectOptions: [
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 }
      ],
      searched: false
    };
  },
  computed: {
    client() {
      return getClient(this.runtimeConfig.elasticsearch);
    }
  },
  methods: {
    // ElasticSearch function to run easier queries and future proofing (ie: text highlighting, filtering, sorting, etc)
    // & also create index (searched) for searched items to log and see what is being searched, when and from what location
    async elasticSearch() {
      let self = this;
      self.searchedFilter = true;

      try {
        self.hits = await this.client.search({
          body: {
            from: self.fromValue,
            size: self.sizeValue,
            query: {
              bool: {
                must: [],
                filter: [
                  {
                    bool: {
                      filter: [
                        {
                          bool: {
                            should: [
                              {
                                match_phrase: {
                                  url: "www.getty.edu/conservation"
                                }
                              }
                            ],
                            minimum_should_match: 1
                          }
                        }
                      ]
                    }
                  },
                  {
                    bool: {
                      filter: [
                        {
                          bool: {
                            should: [
                              {
                                match: {
                                  "metatag.type": {
                                    query: self.type,
                                    operator: "or",
                                    zero_terms_query: "all"
                                  }
                                }
                              }
                            ]
                          }
                        },
                        {
                          bool: {
                            should: [
                              {
                                match: {
                                  "metatag.corearea": {
                                    query: self.area,
                                    operator: "or",
                                    zero_terms_query: "all"
                                  }
                                }
                              }
                            ]
                          }
                        },
                        {
                          bool: {
                            should: [
                              {
                                match: {
                                  "metatag.region": {
                                    query: self.region,
                                    operator: "or",
                                    zero_terms_query: "all"
                                  }
                                }
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ],
                should: [],
                must_not: [
                  {
                    multi_match: {
                      query: "https, nofollow, noindex"
                    }
                  }
                ]
              }
            },
            highlight: {
              fields: {
                title: {
                  fragment_size: 150,
                  number_of_fragments: 1,
                  pre_tags: ["<highlight>"],
                  post_tags: ["</highlight>"],
                  type: "plain"
                },
                DESCRIPTION: {
                  fragment_size: 400,
                  number_of_fragments: 1,
                  pre_tags: ["<highlight>"],
                  post_tags: ["</highlight>"],
                  type: "plain"
                },
                content: {
                  fragment_size: 400,
                  number_of_fragments: 1,
                  pre_tags: ["<highlight>"],
                  post_tags: ["</highlight>"],
                  type: "plain"
                },
                url: {
                  fragment_size: 200,
                  number_of_fragments: 1,
                  pre_tags: ["<highlight>"],
                  post_tags: ["</highlight>"],
                  type: "plain"
                }
              }
            }
          }
        });
        self.searchResults = self.hits.hits.hits;
        if (self.hits.hits.total.value == undefined) {
          self.searchTotals = self.hits.hits.total;
        } else {
          self.searchTotals = self.hits.hits.total.value;
        }
        self.totalPages = Math.ceil(self.searchTotals / self.sizeValue);
        self.resultsCalc();
        self.searched = true;
      } catch (error) {
        console.log(error.message);
      }
    },
    browseFilter: function() {
      this.query = this.$route.query.d;
      if (this.query === "des") {
        this.type = "des";
        this.filterDescription = "Project Descriptions";
      }
      if (this.query === "pub") {
        this.type = "pub";
        this.filterDescription = "Publications";
      }
      if (this.query === "fdl") {
        this.type = "fdl";
        this.filterDescription = "Free PDFs Downloads";
      }
      if (this.query === "tch") {
        this.type = "tch";
        this.filterDescription = "Teaching Resources";
      }
      if (this.query === "pol") {
        this.type = "pol";
        this.filterDescription = "Cultural Heritage Policy Documents";
      }
      if (this.query === "nws") {
        this.type = "nws";
        this.filterDescription = "Newsletters";
      }
      if (this.query === "cnf") {
        this.type = "cnf";
        this.filterDescription = "Lectures and Conferences";
      }
      if (this.query === "arh,des") {
        this.area = "arh";
        this.type = "des";
        this.filterDescription =
          "Archaeological Site Conservation and Management, Project Descriptions";
      }
      if (this.query === "arh,pub") {
        this.area = "arh";
        this.type = "pub";
        this.filterDescription =
          "Archaeological Site Conservation and Management, Publications";
      }
      if (this.query === "arh,tch") {
        this.area = "arh";
        this.type = "tch";
        this.filterDescription =
          "Archaeological Site Conservation and Management, Teaching Resources";
      }
      if (this.query === "arh,nws") {
        this.area = "arh";
        this.type = "nws";
        this.filterDescription =
          "Archaeological Site Conservation and Management, Newsletters";
      }
      if (this.query === "arh,cnf") {
        this.area = "arh";
        this.type = "cnf";
        this.filterDescription =
          "Archaeological Site Conservation and Management, Lectures and Conferences";
      }
      if (this.query === "bld,des") {
        this.area = "bld";
        this.type = "des";
        this.filterDescription = "Building Materials, Project Descriptions";
      }
      if (this.query === "bld,pub") {
        this.area = "bld";
        this.type = "pub";
        this.filterDescription = "Building Materials, Publications";
      }
      if (this.query === "bld,tch") {
        this.area = "bld";
        this.type = "tch";
        this.filterDescription = "Building Materials, Teaching Resources";
      }
      if (this.query === "bld,nws") {
        this.area = "bld";
        this.type = "nws";
        this.filterDescription = "Building Materials, Newsletters";
      }
      if (this.query === "bld,cnf") {
        this.area = "bld";
        this.type = "cnf";
        this.filterDescription = "Building Materials, Lectures and Conferences";
      }
      if (this.query === "pri,des") {
        this.area = "pri";
        this.type = "des";
        this.filterDescription =
          "Conservation Principles and Methods, Project Descriptions";
      }
      if (this.query === "pri,pub") {
        this.area = "pri";
        this.type = "pub";
        this.filterDescription =
          "Conservation Principles and Methods, Publications";
      }
      if (this.query === "pri,tch") {
        this.area = "pri";
        this.type = "tch";
        this.filterDescription =
          "Conservation Principles and Methods, Teaching Resources";
      }
      if (this.query === "pri,nws") {
        this.area = "pri";
        this.type = "nws";
        this.filterDescription =
          "Conservation Principles and Methods, Newsletters";
      }
      if (this.query === "pri,cnf") {
        this.area = "pri";
        this.type = "cnf";
        this.filterDescription =
          "Conservation Principles and Methods, Lectures and Conferences";
      }
      if (this.query === "arr,des") {
        this.area = "arr";
        this.type = "des";
        this.filterDescription = "Decorated Surfaces, Project Descriptions";
      }
      if (this.query === "arr,pub") {
        this.area = "arr";
        this.type = "pub";
        this.filterDescription = "Decorated Surfaces, Publications";
      }
      if (this.query === "arr,tch") {
        this.area = "arr";
        this.type = "tch";
        this.filterDescription = "Decorated Surfaces, Teaching Resources";
      }
      if (this.query === "arr,nws") {
        this.area = "arr";
        this.type = "nws";
        this.filterDescription = "Decorated Surfaces, Newsletters";
      }
      if (this.query === "arr,cnf") {
        this.area = "arr";
        this.type = "cnf";
        this.filterDescription = "Decorated Surfaces, Lectures and Conferences";
      }
      if (this.query === "hst,des") {
        this.area = "hst";
        this.type = "des";
        this.filterDescription =
          "Historic Buildings, Cities and Urban Settlements, Project Descriptions";
      }
      if (this.query === "hst,pub") {
        this.area = "hst";
        this.type = "pub";
        this.filterDescription =
          "Historic Buildings, Cities and Urban Settlements, Publications";
      }
      if (this.query === "hst,tch") {
        this.area = "hst";
        this.type = "tch";
        this.filterDescription =
          "Historic Buildings, Cities and Urban Settlements, Teaching Resources";
      }
      if (this.query === "hst,nws") {
        this.area = "hst";
        this.type = "nws";
        this.filterDescription =
          "Historic Buildings, Cities and Urban Settlements, Newsletters";
      }
      if (this.query === "hst,cnf") {
        this.area = "hst";
        this.type = "cnf";
        this.filterDescription =
          "Historic Buildings, Cities and Urban Settlements, Lectures and Conferences";
      }
      if (this.query === "moa,des") {
        this.area = "moa";
        this.type = "des";
        this.filterDescription = "Modern Architecture, Project Descriptions";
      }
      if (this.query === "moa,pub") {
        this.area = "moa";
        this.type = "pub";
        this.filterDescription = "Modern Architecture, Publications";
      }
      if (this.query === "moa,nws") {
        this.area = "moa";
        this.type = "nws";
        this.filterDescription = "Modern Architecture, Newsletters";
      }
      if (this.query === "moa,cnf") {
        this.area = "moa";
        this.type = "cnf";
        this.filterDescription =
          "Modern Architecture, Lectures and Conferences";
      }
      if (this.query === "rec,des") {
        this.area = "rec";
        this.type = "des";
        this.filterDescription =
          "Recording and Documentation, Project Descriptions";
      }
      if (this.query === "rec,pub") {
        this.area = "rec";
        this.type = "pub";
        this.filterDescription = "Recording and Documentation, Publications";
      }
      if (this.query === "rec,nws") {
        this.area = "rec";
        this.type = "nws";
        this.filterDescription = "Recording and Documentation, Newsletters";
      }
      if (this.query === "rec,cnf") {
        this.area = "rec";
        this.type = "cnf";
        this.filterDescription =
          "Recording and Documentation, Lectures and Conferences";
      }
      if (this.query === "mtl,des") {
        this.area = "mtl";
        this.type = "des";
        this.filterDescription =
          "Artists' Materials and Collections Research, Project Descriptions";
      }
      if (this.query === "mtl,pub") {
        this.area = "mtl";
        this.type = "pub";
        this.filterDescription =
          "Artists' Materials and Collections Research, Publications";
      }
      if (this.query === "mtl,tch") {
        this.area = "mtl";
        this.type = "tch";
        this.filterDescription =
          "Artists' Materials and Collections Research, Teaching Resources";
      }
      if (this.query === "mtl,nws") {
        this.area = "mtl";
        this.type = "nws";
        this.filterDescription =
          "Artists' Materials and Collections Research, Newsletters";
      }
      if (this.query === "mtl,cnf") {
        this.area = "mtl";
        this.type = "cnf";
        this.filterDescription =
          "Artists' Materials and Collections Research, Lectures and Conferences";
      }
      if (this.query === "ana,des") {
        this.area = "ana";
        this.type = "des";
        this.filterDescription =
          "Development of Analytical Methodologies, Project Descriptions";
      }
      if (this.query === "ana,pub") {
        this.area = "ana";
        this.type = "pub";
        this.filterDescription =
          "Development of Analytical Methodologies, Publications";
      }
      if (this.query === "ana,nws") {
        this.area = "ana";
        this.type = "nws";
        this.filterDescription =
          "Development of Analytical Methodologies, Newsletters";
      }
      if (this.query === "ana,cnf") {
        this.area = "ana";
        this.type = "cnf";
        this.filterDescription =
          "Development of Analytical Methodologies, Lectures and Conferences";
      }
      if (this.query === "mod,des") {
        this.area = "mod";
        this.type = "des";
        this.filterDescription =
          "Modern and Contemporary Art, Project Descriptions";
      }
      if (this.query === "mod,pub") {
        this.area = "mod";
        this.type = "pub";
        this.filterDescription = "Modern and Contemporary Art, Publications";
      }
      if (this.query === "mod,nws") {
        this.area = "mod";
        this.type = "nws";
        this.filterDescription = "Modern and Contemporary Art, Newsletters";
      }
      if (this.query === "mod,cnf") {
        this.area = "mod";
        this.type = "cnf";
        this.filterDescription =
          "Modern and Contemporary Art, Lectures and Conferences";
      }
      if (this.query === "pho,des") {
        this.area = "pho";
        this.type = "des";
        this.filterDescription = "Photographs, Project Descriptions";
      }
      if (this.query === "pho,pub") {
        this.area = "pho";
        this.type = "pub";
        this.filterDescription = "Photographs, Publications";
      }
      if (this.query === "pho,tch") {
        this.area = "pho";
        this.type = "tch";
        this.filterDescription = "Photographs, Teaching Resources";
      }
      if (this.query === "pho,nws") {
        this.area = "pho";
        this.type = "nws";
        this.filterDescription = "Photographs, Newsletters";
      }
      if (this.query === "pre,des") {
        this.area = "pre";
        this.type = "des";
        this.filterDescription =
          "Preventive Conservation, Project Descriptions";
      }
      if (this.query === "pre,pub") {
        this.area = "pre";
        this.type = "pub";
        this.filterDescription = "Preventive Conservation, Publications";
      }
      if (this.query === "pre,tch") {
        this.area = "pre";
        this.type = "tch";
        this.filterDescription = "Preventive Conservation, Teaching Resources";
      }
      if (this.query === "pre,nws") {
        this.area = "pre";
        this.type = "nws";
        this.filterDescription = "Preventive Conservation, Newsletters";
      }
      if (this.query === "pre,cnf") {
        this.area = "pre";
        this.type = "cnf";
        this.filterDescription =
          "Preventive Conservation, Lectures and Conferences";
      }
      if (this.query === "ped,des") {
        this.area = "ped";
        this.type = "des";
        this.filterDescription = "Conservation Education, Project Descriptions";
      }
      if (this.query === "ped,pub") {
        this.area = "ped";
        this.type = "pub";
        this.filterDescription = "Conservation Education, Publications";
      }
      if (this.query === "ped,nws") {
        this.area = "ped";
        this.type = "nws";
        this.filterDescription = "Conservation Education, Newsletters";
      }
      if (this.query === "ped,cnf") {
        this.area = "ped";
        this.type = "cnf";
        this.filterDescription =
          "Conservation Education, Lectures and Conferences";
      }
      if (this.query === "ssa,des") {
        this.region = "ssa";
        this.type = "des";
        this.filterDescription = "Sub-Saharan Afric, Project Descriptions";
      }
      if (this.query === "ssa,pub") {
        this.region = "ssa";
        this.type = "pub";
        this.filterDescription = "Sub-Saharan Afric, Publications";
      }
      if (this.query === "ssa,nws") {
        this.region = "ssa";
        this.type = "nws";
        this.filterDescription = "Sub-Saharan Afric, Newsletters";
      }
      if (this.query === "ssa,cnf") {
        this.region = "ssa";
        this.type = "cnf";
        this.filterDescription = "Sub-Saharan Afric, Lectures and Conferences";
      }
      if (this.query === "ame,des") {
        this.region = "ame";
        this.type = "des";
        this.filterDescription =
          "Middle East and North Africa, Project Descriptions";
      }
      if (this.query === "ame,pub") {
        this.region = "ame";
        this.type = "pub";
        this.filterDescription = "Middle East and North Africa, Publications";
      }
      if (this.query === "ame,nws") {
        this.region = "ame";
        this.type = "nws";
        this.filterDescription = "Middle East and North Africa, Newsletters";
      }
      if (this.query === "ame,cnf") {
        this.region = "ame";
        this.type = "cnf";
        this.filterDescription =
          "Middle East and North Africa, Lectures and Conferences";
      }
      if (this.query === "eur,des") {
        this.region = "eur";
        this.type = "des";
        this.filterDescription = "Europe, Project Descriptions";
      }
      if (this.query === "eur,pub") {
        this.region = "eur";
        this.type = "pub";
        this.filterDescription = "Europe, Publications";
      }
      if (this.query === "eur,tch") {
        this.region = "eur";
        this.type = "tch";
        this.filterDescription = "Europe, Teaching Resources";
      }
      if (this.query === "eur,nws") {
        this.region = "eur";
        this.type = "nws";
        this.filterDescription = "Europe, Newsletters";
      }
      if (this.query === "eur,cnf") {
        this.region = "eur";
        this.type = "cnf";
        this.filterDescription = "Europe, Lectures and Conferences";
      }
      if (this.query === "asi,des") {
        this.region = "asi";
        this.type = "des";
        this.filterDescription = "Asia, Project Descriptions";
      }
      if (this.query === "asi,pub") {
        this.region = "asi";
        this.type = "pub";
        this.filterDescription = "Asia, Publications";
      }
      if (this.query === "asi,tch") {
        this.region = "asi";
        this.type = "tch";
        this.filterDescription = "Asia, Teaching Resources";
      }
      if (this.query === "asi,nws") {
        this.region = "asi";
        this.type = "nws";
        this.filterDescription = "Asia, Newsletters";
      }
      if (this.query === "asi,cnf") {
        this.region = "asi";
        this.type = "cnf";
        this.filterDescription = "Asia, Lectures and Conferences";
      }
      if (this.query === "naa,des") {
        this.region = "naa";
        this.type = "des";
        this.filterDescription = "North America, Project Descriptions";
      }
      if (this.query === "naa,pub") {
        this.region = "naa";
        this.type = "pub";
        this.filterDescription = "North America, Publications";
      }
      if (this.query === "naa,nws") {
        this.region = "naa";
        this.type = "nws";
        this.filterDescription = "North America, Newsletters";
      }
      if (this.query === "naa,cnf") {
        this.region = "naa";
        this.type = "cnf";
        this.filterDescription = "North America, Lectures and Conferences";
      }
      if (this.query === "saa,des") {
        this.region = "saa";
        this.type = "des";
        this.filterDescription = "South America, Project Descriptions";
      }
      if (this.query === "saa,pub") {
        this.region = "saa";
        this.type = "pub";
        this.filterDescription = "South America, Publications";
      }
      if (this.query === "saa,tch") {
        this.region = "saa";
        this.type = "tch";
        this.filterDescription = "South America, Teaching Resources";
      }
      if (this.query === "saa,nws") {
        this.region = "saa";
        this.type = "nws";
        this.filterDescription = "South America, Newsletters";
      }
      if (this.query === "saa,cnf") {
        this.region = "saa";
        this.type = "cnf";
        this.filterDescription = "South America, Lectures and Conferences";
      }
      if (this.query === "oca,des") {
        this.region = "oca";
        this.type = "des";
        this.filterDescription = "Oceania, Project Descriptions";
      }
      if (this.query === "oca,pub") {
        this.region = "oca";
        this.type = "pub";
        this.filterDescription = "Oceania, Publications";
      }
      if (this.query === "oca,nws") {
        this.region = "oca";
        this.type = "nws";
        this.filterDescription = "Oceania, Newsletters";
      }
      if (this.query === "oca,cnf") {
        this.region = "oca";
        this.type = "cnf";
        this.filterDescription = "Oceania, Lectures and Conferences";
      }
      this.elasticSearch();
    },
    // calc resutls depending if page is 0, less then the sizeValue or over sizeValue
    resultsCalc: function() {
      if (this.fromValue === 0) {
        if (this.searchResults.length === 0) {
          this.startResults = 0;
          this.endResults = 0;
          this.currentPage = 0;
          this.endPage = 0;
        } else {
          if (this.searchResults.length < this.sizeValue) {
            this.startResults = 1;
            this.endResults = this.searchTotals;
          } else {
            this.startResults = 1;
            this.endResults = this.fromValue + this.sizeValue;
          }
        }
      } else {
        if (this.searchResults.length !== 0) {
          this.startResults = this.fromValue;
          this.endResults = this.fromValue + this.sizeValue;
        }
        if (this.currentPage === this.totalPages) {
          this.endResults = this.searchTotals;
        }
      }
    },
    modSearch: function() {
      this.searchedFilter = false;
      this.searched = false;
      this.filterDescription = "";
      this.filter = "";
      this.filterBy = "";
    },
    // function to move the page back 50 results
    prevButton: function() {
      this.fromValue -= this.sizeValue;
      this.currentPage -= 1;
      this.elasticSearch();
    },
    // function to move page forward 50 results
    nextButton: function() {
      this.fromValue += this.sizeValue;
      this.currentPage += 1;
      this.elasticSearch();
    }
  },
  created() {
    this.browseFilter();
  },
  components: {
    LoadingBar
  }
};
</script>

<style scoped lang="scss">
.pagination {
  justify-content: flex-end !important;
  .button {
    border: none;
    span {
      color: $blue;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.search-results-info {
  text-align: right;
}
.results {
  font-size: 0.875em;
  display: block;
  padding: 0.5em 0;
  span {
    display: block;
  }
  .results-image {
    padding-right: 1em;
    img {
      width: 50px;
      max-width: inherit;
    }
  }
  .results-title {
    max-width: 676px;
    font-weight: 800;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
